import { useState, useCallback, useMemo } from "react";
import Carousel from "@/components/ui/carousel/carousel";
import { SwiperSlide } from "swiper/react";
import { m } from "framer-motion";
// import VideoBanner from "@/components/ui/video-banner";
import Link from "next/link";
import dynamic from "next/dynamic";

const VideoBanner = dynamic(() => import("@/components/ui/video-banner"), {
  ssr: true,
  loading: () => <div>Loading Video...</div>,
});

const debounce = (func, delay) => {
  let timer;
  return (...args) => {
    clearTimeout(timer);
    timer = setTimeout(() => func(...args), delay);
  };
};

const Banner = ({ data }) => {
  const [currentSlide, setCurrentSlide] = useState(0);

  const handleSlideChange = useCallback(
    debounce((newSlide) => setCurrentSlide(newSlide), 100),
    []
  );

  const currentData = useMemo(
    () => data[currentSlide]?.project?.data?.attributes,
    [currentSlide, data]
  );

  return (
    <div className="homeBanner w-full relative">
      <Carousel
        slidesPerView={1}
        spaceBetween={0}
        loop={true}
        className="featureCarousel w-full my-8"
        navigation={true}
        pagination={false}
        showNavAbove={false}
        total={data.length}
        autoplay={{
          delay: 5000,
          disableOnInteraction: false,
          pauseOnMouseEnter: false,
        }}
        setCurrentSlide={handleSlideChange}
        customPagination={true}
      >
        {data?.map((row, key) => (
          <SwiperSlide key={"homeBanner" + key}>
            <Link
              href={"/projects/" + row?.project?.data?.attributes?.slug}
              className="w-full h-full"
              aria-label={`View project: ${row?.project?.data?.attributes?.title}`}
            >
              <VideoBanner
                data={{ video: row?.video?.data?.attributes?.url }}
              />
            </Link>
          </SwiperSlide>
        ))}
      </Carousel>

      <div className="fixed bottom-24 left-0 w-full transform z-[1]">
        <m.h2
          key={currentSlide} // This key ensures that the element will be re-rendered on slide change
          initial={{ y: 100, opacity: 0 }}
          whileInView={{ y: 0, opacity: 100 }}
          exit={{ y: 100, opacity: 0 }}
          transition={{ duration: 0.75, delay: 0.5 }}
          className="text-center text-white mx-auto w-fit font-extralight font-havletica uppercase"
        >
          {currentData?.title}
        </m.h2>
      </div>

      <div className="fixed lg:bottom-20 bottom-16 md:left-20 left-4 w-fit transform z-[1]">
        <m.div
          key={currentSlide} // This key ensures that the element will be re-rendered on slide change
          initial={{ y: 40, opacity: 0 }}
          whileInView={{ y: 0, opacity: 100 }}
          exit={{ y: 40, opacity: 0 }}
          transition={{ duration: 0.75, delay: 0.5 }}
          className="text-center text-[#F6F5F1] mx-auto md:text-base text-sm font-light uppercase"
        >
          {currentData?.location}
        </m.div>
      </div>
      <div className="fixed lg:bottom-20 bottom-16 md:right-20 right-4 w-fit transform z-[1]">
        <m.div
          key={currentSlide} // This key ensures that the element will be re-rendered on slide change
          initial={{ y: 40, opacity: 0 }}
          whileInView={{ y: 0, opacity: 100 }}
          exit={{ y: 40, opacity: 0 }}
          transition={{ duration: 0.75, delay: 0.5 }}
          className="text-center text-[#F6F5F1] mx-auto md:text-base text-sm font-light uppercase"
        >
          {currentData?.projectType}
        </m.div>
      </div>
    </div>
  );
};

export default Banner;
